<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('absences.add_file') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <div>
              <div class="accordion accordion-icon-toggle" id="kt_accordion_2">
                <div class="col-12" v-for="(file, index) in files" :key="index">
                  <div class="accordion-header py-3 d-flex" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_2_item_'+index">
                    <span class="accordion-icon">
                        <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                    </span>
                    <h1 class="fs-4 fw-semibold mb-0 ms-5"> {{ file.file }} </h1>
                    <span class="haveBorder flex-grow-1 ms-3"></span>
                  </div>
                  <div :id="'kt_accordion_2_item_'+index" class="fs-6 collapse ps-10" :class="!index && 'show'" data-bs-parent="#kt_accordion_2">
                    <div class="w-100">
                      <object v-if="!isImage(file.file_url)" :data='file.file_url' width="100%" height="678">
                        <iframe :src='file.file_url' width="500" height="678"></iframe>
                      </object>
                      <div v-else class="col-md-12 d-flex justify-content-center align-items-center">
                        <img :src="file.file_url" :alt="file.file" class="img" style="width: 100%; height: 600px;object-fit: contain">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {ref, defineProps} from 'vue'
import Button from "@/components/Button.vue"

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    files: {
      type: Object,
      default: {}
    },
})

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function isImage(url) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
}
</script>